<template>
  <div class="google-auth-guide">
    <div class="header">
      <img src="@/assets/loginLogo.png" alt="logo" class="logo" />
    </div>
    <div class="content">
      <div class="tab-container" style="display: flex">
        <div style="flex: 1" class="tab-item" :class="{ active: activeTab === 'get' }" @click="activeTab = 'get'">
          {{
            $i18n.locale == lang.enUS
              ? 'How to get Google verification code?'
              : 'Làm thế nào để lấy mã xác thực Google?'
          }}
        </div>
        <div style="flex: 1" class="tab-item" :class="{ active: activeTab === 'check' }" @click="activeTab = 'check'">
          {{
            $i18n.locale == lang.enUS
              ? 'Check if my account is bound?'
              : 'Kiểm tra xem tài khoản của tôi đã liên kết mã Google hay chưa?'
          }}
        </div>
      </div>

      <div class="guide-content" v-if="activeTab === 'get'">
        <div class="step">
          <span class="step-number">1.</span>
          <span class="step-text">{{
            $i18n.locale == lang.enUS ? 'Download [Authenticator] APP' : 'Tải xuống ứng dụng Authenticator'
          }}</span>
        </div>
        <div class="step">
          <span class="step-number">2.</span>
          <span class="step-text">{{
            $i18n.locale == lang.enUS
              ? 'Open [Authenticator] APP and scan QR code to bind'
              : 'Mở ứng dụng Authenticator và quét mã để liên kết'
          }}</span>
        </div>
        <div class="step">
          <span class="step-number">3.</span>
          <span class="step-text">{{
            $i18n.locale == lang.enUS
              ? 'After binding successfully, you can view the verification code in [Authenticator] APP'
              : 'Sau khi liên kết thành công, bạn có thể xem mã xác thực trong ứng dụng Authenticator'
          }}</span>
        </div>
      </div>

      <div class="guide-content" v-if="activeTab === 'check'">
        <div class="query-form">
          <a-form :form="form" layout="vertical">
            <a-form-item>
              <a-input
                size="large"
                type="text"
                :placeholder="
                  $i18n.locale == lang.enUS ? 'Please enter your login account' : 'Vui lòng nhập tài khoản đăng nhập'
                "
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        message:
                          $i18n.locale == lang.enUS ? 'Please enter login account' : 'Vui lòng nhập mật khẩu đăng nhập',
                      },
                    ],
                  },
                ]"
              >
                <a-icon slot="prefix" type="user" />
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-input
                size="large"
                type="password"
                :placeholder="
                  $i18n.locale == lang.enUS
                    ? 'Please enter your login password'
                    : 'Vui lòng nhập mật khẩu đăng nhập của bạn'
                "
                v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message:
                          $i18n.locale == lang.enUS
                            ? 'Please enter login password'
                            : 'Vui lòng nhập mật khẩu đăng nhập',
                      },
                    ],
                  },
                ]"
              >
                <a-icon slot="prefix" type="lock" />
              </a-input>
            </a-form-item>

            <a-form-item>
              <a-button type="primary" size="large" block @click="handleQuery" :loading="loading">
                {{ $i18n.locale == lang.enUS ? 'Query' : 'Truy vấn' }}
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>

      <div class="back-btn">
        <a-button type="primary" @click="goBack">{{
          $i18n.locale == lang.enUS ? 'Back to Login' : 'Quay lại đăng nhập'
        }}</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { message } from 'ant-design-vue'
import lang from '../../i18n/lang'

export default {
  name: 'GoogleAuthGuide',
  data() {
    return {
      activeTab: 'get',
      form: null,
      loading: false,
      lang,
    }
  },
  created() {
    this.form = this.$form.createForm(this)
  },
  methods: {
    goBack() {
      this.$router.push('/user/login')
    },
    handleQuery() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          setTimeout(() => {
            this.loading = false
            message.success(
              this.$i18n.locale == lang.enUS
                ? 'Query function is under development, please log in to the system directly to view'
                : 'Chức năng truy vấn đang được phát triển, vui lòng đăng nhập trực tiếp vào hệ thống để xem'
            )
          }, 1000)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.google-auth-guide {
  min-height: 100vh;
  background: #fff;
}

.header {
  padding: 24px;
  border-bottom: 1px solid #e8e8e8;
  text-align: left;

  .logo {
    height: 40px;
  }
}

.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 48px 24px;
}

.tab-container {
  display: flex;
  justify-content: center;
  margin-bottom: 48px;
  border: 1px solid #1890ff;
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.tab-item {
  padding: 12px 32px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s;
  color: #1890ff;
  background: #fff;

  &:hover {
    background: #e6f7ff;
  }

  &.active {
    background: #1890ff;
    color: #fff;
  }
}

.guide-content {
  margin-bottom: 48px;
}

.step {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  font-size: 16px;
  line-height: 1.6;
  .step-text {
    color: #333;
  }
}

.back-btn {
  text-align: center;
  margin-top: 48px;

  button {
    width: 200px;
    height: 40px;
    font-size: 16px;
  }
}

.query-form {
  max-width: 400px;
  margin: 0 auto;
  padding: 24px;
  border: 2px solid #1890ff;
  border-radius: 8px;
  background: #f5f5f5;

  /deep/ .ant-form-item {
    margin-bottom: 24px;
  }

  /deep/ .ant-input-affix-wrapper {
    border-radius: 4px;

    &:hover .ant-input:not(.ant-input-disabled) {
      border-color: #1890ff;
    }
  }

  /deep/ .ant-input {
    font-size: 14px;
  }

  /deep/ .ant-btn-primary {
    height: 40px;
    font-size: 16px;
    border-radius: 4px;
  }
}
</style>
